﻿//Utilities
import { useQuery } from '@tanstack/react-query';
//Components
import { WizardButtons } from '../../Wizard/WizardButtons';
import { Alert, Stack, Paper, styled } from '@mui/material';
import { GetOwnershipChangeInformation } from '../../../../../api/ownershipchange';
import { TitledCircularProgress } from '../../feedback/TitledCircularProgress/TitledCircularProgress';
//Styles
import './ownershipStyles.css';

const ConfirmPrimaryOwner = (props) => {
  const getOwnershipInfo = useQuery({
    queryKey: ['getOwnershipInfo', props.referenceID],
    queryFn: async () => await GetOwnershipChangeInformation({ PolicyID: props.referenceID })(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!props.referenceID,
  });

  const ValidateForm = () => {
    props.nextHandler();
  };

  if (getOwnershipInfo.isPending || getOwnershipInfo.isFetching)
    return <TitledCircularProgress title="Checking Policy" />;

  return (
    <>
      <form>
        <Stack spacing={2}>
          <Alert severity="info">Please confirm Primary Owner Info below before continuing</Alert>
          <OwnerFormItem>
            <span className="formLabel">Policy Number:</span>
            <span className="fullWidth">
              {getOwnershipInfo.data != null && getOwnershipInfo.data.policyID}
            </span>
          </OwnerFormItem>
          <OwnerFormItem>
            <span className="formLabel">Primary Owner Name:</span>
            <span className="fullwidth">
              {getOwnershipInfo.data != null && getOwnershipInfo.data.ownerName}
            </span>
          </OwnerFormItem>
          <OwnerFormItem>
            <span className="formLabel">Owner Last 4:</span>
            <span className="fullwidth">
              {getOwnershipInfo.data != null && getOwnershipInfo.data.ownerLast4}
            </span>
          </OwnerFormItem>
        </Stack>
      </form>
      <WizardButtons {...props} nextHandler={ValidateForm} />
    </>
  );
};
const decideColor = (theme) => {
  let color = '';
  if (theme.palette.mode === 'dark') {
    color = '#1A2027';
  } else {
    color = '#FFF';
  }
};
const OwnerFormItem = styled(Paper)(({ theme }) => ({
  backgroundColor: decideColor(theme),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '.25em',
  color: theme.palette.text.secondary,
}));

export { ConfirmPrimaryOwner };
